/**
 * Returns a callback to set focus to the search input.
 * @param {Element} component
 * @returns {Function}
 */
const handleInputFocus = (component) => () => {
    $(component).find('.search__input').focus();
};

export default handleInputFocus;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handleInputFocus.js